import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { NAV_LIST, hasAnyPermission } from '@/common/js/constant/index.ts';
let MobileNav = class MobileNav extends Vue {
    get filteredNavList() {
        return NAV_LIST.filter((item) => {
            const platformMatch = item.platform.includes('mobile');
            const permissionMatch = !item.requiredPermissions
                || item.requiredPermissions.length === 0
                || hasAnyPermission(...item.requiredPermissions);
            return platformMatch && permissionMatch;
        });
    }
    get curNav() {
        const routeList = this.$route.matched;
        for (const route of routeList) {
            for (const nav of this.filteredNavList) {
                if (nav.name === route.name) {
                    return nav.name;
                }
            }
        }
        return '';
    }
};
MobileNav = __decorate([
    Component
], MobileNav);
export default MobileNav;
